module.exports = __webpack_public_path__ + "static/media/Sajek.c530f679.png";